import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { Group } from "../../models/group.model";
import { DashboardDataProvider } from "../../data-provider/dashboard.dp";
import { DashboardWidgetFilter } from "../../models/dashboard-widget-filter.model";
import { Dashboard } from "../../models/dashboard.model";
import { Effort } from "../../models/effort.model";
import * as _ from "lodash";
import { SurveyService } from "../../services/survey.service";
import { Campaign } from "../../models/campaign.model";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { AppTypeDataProvider } from "../../data-provider/app-type.dp";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { ChartHelper } from "../result/chart.helper";

let GroupDashboardComponent = {
    selector: "vcGroupDashboard",
    templateUrl: "/angular/components/group/group-dashboard.component.html",
    bindings: {
        group: "=",
        size: "=?",
        inDialog: "=?",
    },
    controller: class GroupDashboardController {
        // * bindings for typescript compiler *
        public group: Group;
        public size: string;
        public inDialog: boolean;
        // ************************************
        private readonly $scope: any;
        private dialog: DialogUtils;
        private dashboardDataProvider: DashboardDataProvider;
        public filter?: DashboardWidgetFilter;
        public dashboards: Dashboard[];
        public dashboard: Dashboard;
        public hideFirstDashboard: boolean = false;
        public surveys: object[];
        public selectedSurvey: object | undefined;
        public surveyService: SurveyService;
        public app_type: string | null;
        public activeCampaign: Campaign;
        public effortDataProvider: EffortDataProvider;
        public appTypeDataProvider: AppTypeDataProvider;
        public effort: Effort;
        public efforts: Effort[];
        public surveyLoading: boolean = true;
        public chartHelper: ChartHelper;

        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            SurveyService: SurveyService,
            __app_type: string,
            EffortDataProvider: EffortDataProvider,
            DashboardDataProvider: DashboardDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            ChartHelper: ChartHelper,
            AppTypeDataProvider: AppTypeDataProvider
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.dashboardDataProvider = DashboardDataProvider;
            this.surveyService = SurveyService;
            this.activeCampaign = CampaignDataProvider.activeCampaign;
            this.app_type = AppTypeDataProvider.getAppType();
            this.effortDataProvider = EffortDataProvider;
            this.appTypeDataProvider = AppTypeDataProvider;
            this.chartHelper = ChartHelper;

            this.$scope.$watch(
                () => this.group.gid,
                (newValue: string, oldValue: string) => {
                    if (oldValue && newValue !== oldValue) {
                        this.filter = new DashboardWidgetFilter();
                        this.filter.dateRange = {};
                        this.filter.groups = [
                            {
                                gid: this.group.gid,
                                gname: this.group.gname,
                            },
                        ];
                    }
                }
            );

            this.effortDataProvider
                .getAllEfforts()
                .then((efforts: Effort[]) => {
                    this.efforts = efforts;

                    this.effortDataProvider
                        .getSelectedEffort()
                        .then((effort: Effort) => {
                            this.effort = effort;
                            this.loadSurveys();
                        });
                });
        }

        $onInit() {
            if (!this.size) {
                this.size = "default";
            }
            this.filter = new DashboardWidgetFilter();
            this.filter.dateRange = {};
            this.filter.groups = [
                {
                    gid: this.group.gid,
                    gname: this.group.gname,
                },
            ];

            this.loadDashboards();

            this.$scope.$watch(
                () => this.group.gid,
                (newValue: string, oldValue: string) => {
                    if (oldValue && newValue !== oldValue) {
                        this.loadSurveyData(this.selectedSurvey, this.effort);
                    }
                }
            );

            this.$scope.$watch(
                () => this.app_type,
                (newValue: string, oldValue: string) => {
                    if (oldValue && newValue !== oldValue) {
                        this.effortDataProvider.setSelectedEffort();
                        this.appTypeDataProvider.setAppType(newValue);
                        this.loadSurveyData(this.selectedSurvey, this.effort);
                    }
                }
            );

            this.$scope.$watch(
                () => this.effort,
                (newValue: Effort, oldValue: Effort) => {
                    if (oldValue && newValue !== oldValue) {
                        this.effortDataProvider.setSelectedEffort(newValue);
                        this.loadSurveyData(this.selectedSurvey, this.effort);
                    }
                },
                true
            );
        }

        loadSurveys(): void {
            this.surveyService
                .all({ category: this.app_type })
                .then((response: object) => {
                    const json = response["data"];
                    this.surveys = json.data;
                    this.selectedSurvey = this.surveys[0];
                    this.loadSurveyData(this.selectedSurvey, this.effort);
                });
        }

        loadSurveyData(survey: any, effort: Effort): void {
            this.surveyLoading = true;
            if (!survey) {
                this.surveyLoading = false;
                return;
            }
            let effID = effort.id;
            let svID: string;
            if (survey) svID = survey.sid;
            this.surveyService
                .info(svID, {
                    gid: this.group.gid,
                    category: this.app_type,
                    effortid: effID,
                })
                .then((response: object) => {
                    const json = response["data"];
                    this.surveyLoading = false;
                    if (json.success) {
                        survey.questions = [];
                        _.merge(survey, json.data);

                        let i = 0;
                        angular.forEach(survey.questions, (question: any) => {
                            if (question.atid != "3") {
                                question.total =
                                    this.chartHelper.calculateSurveyChartDetails(
                                        question.choices,
                                        this.chartHelper.colorPalettes[i]
                                    );
                                i++;
                                angular.forEach(
                                    question.choices,
                                    (choice: any) => {
                                        choice.label = choice.aname;
                                    }
                                );
                            } else {
                                angular.forEach(
                                    json.data.questions,
                                    (free_text_question: any) => {
                                        if (
                                            question.sqid ==
                                            free_text_question.sqid
                                        ) {
                                            question.given_answers =
                                                free_text_question.given_answers;
                                        }
                                    }
                                );
                            }
                        });
                    } else {
                        survey.questions = [];
                    }
                });
        }

        openGroupStatsDialog(group: Group, ev: object): void {
            this.hideFirstDashboard = true;
            this.dialog
                .show({
                    component: "vc-group-info-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    size: "x-large",
                    locals: {
                        group: group,
                    },
                })
                .then((newGroup: Group) => {
                    this.hideFirstDashboard = false;
                    angular.extend(group, newGroup);
                });
        }

        close(group: Group): void {
            this.dialog.hide(group);
        }

        loadDashboards() {
            this.dashboardDataProvider
                .group()
                .then((dashboards: Dashboard[]): void => {
                    this.dashboards = dashboards;
                    let selectedDash: Dashboard = this.dashboards[0];
                    this.switchDashboard(selectedDash);
                });
        }

        switchDashboard(dashboard: Dashboard): void {
            if (!this.dashboard || dashboard.id != this.dashboard.id) {
                this.dashboard = dashboard;
            }
        }

        filterDashboards(accessType: string): Dashboard[] {
            if (this.dashboards) {
                if (accessType == "private") {
                    return this.dashboards.filter((dashboard: Dashboard) => {
                        return dashboard.uid != null;
                    });
                } else {
                    return this.dashboards.filter((dashboard: Dashboard) => {
                        return dashboard.uid == null;
                    });
                }
            }
            return [];
        }
    },
};

angular
    .module("group")
    .component(GroupDashboardComponent.selector, GroupDashboardComponent);
